import { EventEmitter } from 'events';

const emiter = new EventEmitter();

export default emiter;

//租车事件
export const EVENT_VEHICLE_SEARCH_LIST = 'EVENT_VEHICLE_SEARCH_LIST';
export const EVENT_VEHICLE_ADD_CAR = 'EVENT_VEHICLE_ADD_CAR';
export const EVENT_VEHICLE_BATCH_UPLOAD = 'EVENT_VEHICLE_BATCH_UPLOAD';
export const EVENT_VEHICLE_EXCHANGE_STORE = 'EVENT_VEHICLE_EXCHANGE_STORE';
export const EVENT_VEHICLE_EDIT_CAR = 'EVENT_VEHICLE_EDIT_CAR';
export const EVENT_VEHICLE_VIEW_CAR = 'EVENT_VEHICLE_VIEW_CAR';
export const EVENT_VEHICLE_RESEARCH = 'EVENT_VEHICLE_RESEARCH';
export const EVENT_VEHICLE_TYPE = 'EVENT_VEHICLE_TYPE';
export const EVENT_VEHICLE_SEARCH_SERIES = 'EVENT_VEHICLE_SEARCH_SERIES';
export const EVENT_VEHICLE_SEARCH_VEHICLE = 'EVENT_VEHICLE_SEARCH_VEHICLE';
export const EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN = 'EVENT_VEHICLE_SEARCH_VEHICLE_LISTEN';
export const EVENT_VEHICLE_SEARCH_SERIES_LISTEN = 'EVENT_VEHICLE_SEARCH_SERIES_LISTEN';

//门店管理
export const EVENT_CARRENTAL_SEARCH_STORELIST_TYPE = 'EVENT_CARRENTAL_SEARCH_STORELIST_TYPE';
export const EVENT_CARRENTAL_ADD_STORE = 'EVENT_CARRENTAL_ADD_STORE';
export const EVENT_CARRENTAL_STORE_EDIT = 'EVENT_CARRENTAL_STORE_EDIT';
export const EVENT_CARRENTAL_STORE_VIEW = 'EVENT_CARRENTAL_STORE_VIEW';
export const EVENT_CARRENTAL_STORE_DAY_OFF = 'EVENT_CARRENTAL_STORE_DAY_OFF';
export const EVENT_CARRENTAL_ADD_REST_DAY = 'EVENT_CARRENTAL_ADD_REST_DAY';
export const EVENT_CARRENTAL_STORE_SEARCH = 'EVENT_CARRENTAL_STORE_SEARCH';
export const EVENT_CARRENTAL_BRANCH_MODAL_OPEN = 'EVENT_CARRENTAL_BRANCH_MODAL_OPEN';
export const EVENT_CARRENTAL_BRANCH_ADD = 'EVENT_CARRENTAL_BRANCH_ADD';
export const EVENT_CARRENTAL_BRANCH_VIEW = 'EVENT_CARRENTAL_BRANCH_VIEW';

export const EVENT_CARRENTAL_ADD_REMOTERETURN = 'EVENT_CARRENTAL_ADD_REMOTERETURN';
export const EVENT_CARRENTAL_EDIT_REMOTERETURN = 'EVENT_CARRENTAL_EDIT_REMOTERETURN';
export const EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY = 'EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY';
export const EVENT_CARRENTAL_EDITTABLE_ADDROW = 'EVENT_CARRENTAL_EDITTABLE_ADDROW';
export const EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL = 'EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL';
export const EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST = 'EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST';
export const EVENT_CARRENTAL_UPDATE_WEBSITE_LIST = 'EVENT_CARRENTAL_UPDATE_WEBSITE_LIST';
export const EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH = 'EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH';
export const EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL = 'EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL';

//门店评分管理
export const EVENT_CARRENTAL_STORE_RATING= 'EVENT_CARRENTAL_STORE_RATING';
export const EVENT_CARRENTAL_STORE_TEXT = 'EVENT_CARRENTAL_STORE_TEXT'

//车辆管理
export const EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH = 'EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH';
export const EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN = 'EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN';
export const EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH =
	'EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH';
export const EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_MODE_TYPE =
  'EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_MODE_TYPE';
export const EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH = 'EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH';
export const EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH_FROM_SEARCH = 'EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH_FROM_SEARCH'


//员工管理
export const EVENT_CARRENTAL_EMPLOYEE_ADD = 'EVENT_CARRENTAL_EMPLOYEE_ADD';
export const EVENT_CARRENTAL_EMPLOYEE_EDIT = 'EVENT_CARRENTAL_EMPLOYEE_EDIT';
export const EVENT_CARRENTAL_EMPLOYEE_VIEW = 'EVENT_CARRENTAL_EMPLOYEE_VIEW';
export const EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL = 'EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL';
export const EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST = 'EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST';
export const EVENT_CARRENTAL_ROLE_SEARCH_LIST = 'EVENT_CARRENTAL_ROLE_SEARCH_LIST';
export const EVENT_CARRENTAL_ROLE_OPEN_DETAIL = 'EVENT_CARRENTAL_ROLE_OPEN_DETAIL';
export const EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE = 'EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE';

// TODO 事件名待确认
export const _EVENTS = {
	PRODUCT_PRICE: {
		CAR_MODEL_PRICE: {
			SEARCH: 'e1',
			EDIT: 'e2',
			VIEW: 'e3',
			ADD: 'e4',
			OPEN_MODEL: 'e21',
			EDIT_PRICE: 'e26',
			WEEKEND_PRICE: 'e27',
			CLOSE_DRAW: 'e28',
			CLEAR_DATES: 'e29',
			INTERVAL_PRICE: 'e30',
		},
		VALUE_ADDED_PRICE: {
			SEARCH: 'e5',
			EDIT: 'e6',
			VIEW: 'e7',
			ADD: 'e8',
			OPEN_MODEL: 'e22',
      CHANGE_LEVEL: 'a10'
		},
		BOOKING_RULE: {
			SEARCH: 'e9',
			EDIT: 'e10',
			VIEW: 'e11',
			ADD: 'e12',
			OPEN_MODEL: 'e23',
		},
		SERVICE_POLICY: {
			SEARCH: 'e13',
			EDIT: 'e14',
			VIEW: 'e15',
			ADD: 'e16',
			OPEN_MODEL: 'e24',
		},
		CANCEL_RULE: {
			SEARCH: 'e17',
			EDIT: 'e18',
			VIEW: 'e19',
			ADD: 'e20',
			OPEN_MODEL: 'e25',
		},
	},
	ORDER_MANAGEMENT: {
		ORDER_LIST: {
			SEARCH: 'e31',
			VIEW: 'e32',
			ARRANGE_CAR: 'e33',
			ARRANGE_CHANGE: 'e34',
			ORDER_REMARK: '39',
			ARRANGE_DRIVER: 'e35',
			AGREE_RENEW: 'e36',
			REFUSE_RENEW: 'e37',
			FEE_RENEW: 'e38',
			REFUND: 'e39',
			DEPOSIT_REFUND: 'e43',
			DEDUCTION: 'e40',
			UNFREEZING_DEPOSIT: 'e41',
			REFRESH: 'e42',
		},
	},
	NOTIFICATION: {
		NOTIFICATION_LIST: {
			SEARCH: 'e44',
			VIEW: 'e45',
			MODAL: 'e46',
			TOPMSG:'e47',
		},
		CS_ORDER_LIST: {
			SEARCH: 'EVENT_NOTIFICATION_CS_ORDER_LIST_SEARCH',
			VIEW: 'EVENT_NOTIFICATION_CS_ORDER_LIST_VIEW',
			REFRESH: 'EVENT_NOTIFICATION_CS_ORDER_LIST_REFRESH'
		}
	},

	COMMON_EMIT: {
		COMMON_UPLOAD_EMIT: 'COMMON_UPLOAD_EMIT',
    CAR_MODEL_CASCADER_PARAMS_EVENT: 'CAR_MODEL_CASCADER_PARAMS_EVENT'
	},
  ACTIVES: {
    DIDI_SECTION: {
      SEARCH: 'DIDI_SECTION_SEARCH',
    },
    TAKE_THE_LEAD: {
      SEARCH: 'TAKE_THE_LEAD_SEARCH',
      ADD: 'TAKE_THE_LEAD_ADD',
      VIEW: 'TAKE_THE_LEAD_VIEW',
      EDIT: 'TAKE_THE_LEAD_EDIT',
      UPDATE_STATUS: 'TAKE_THE_LEAD_UPDATE_STATUS',
    }
  }
};
